const BG_KEY = 'cap_background_at'
const LOCK_AFTER_MS = 2 * 60 * 1000 // 2 min

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const router = useRouter()

  try {
    import('@capacitor/app').then(({ App: CapApp }) => {
      CapApp.addListener('appUrlOpen', (event: { url: string }) => {
        const url = new URL(event.url)

        if (url.pathname.includes('/auth/reset-password')) {
          const token = url.searchParams.get('token')
          if (token) router.push(`/auth/reset-password?token=${token}`)
          return
        }

        if (url.pathname.includes('/auth/onboarding')) {
          const token = url.searchParams.get('token')
          if (token) router.push(`/auth/onboarding?token=${token}`)
          return
        }

        if (url.pathname.includes('/app/billing')) {
          router.push('/app/billing')
        }
      })

      CapApp.addListener('appStateChange', async ({ isActive }: { isActive: boolean }) => {
        if (!isActive) {
          // Persiste no localStorage para sobreviver a kills do processo
          const now = String(Date.now())
          localStorage.setItem(BG_KEY, now)
          return
        }

        const auth = useAuthStore()
        if (!auth.accessToken) return

        // Lê quando o app foi para background (mesmo após kill do processo)
        const savedAt = Number(localStorage.getItem(BG_KEY) ?? '0')

        if (savedAt > 0) {
          const awayMs = Date.now() - savedAt
          localStorage.removeItem(BG_KEY)
          if (awayMs > LOCK_AFTER_MS) {
            // Ficou em background por mais de 2 min → logout obrigatório
            auth.clearAuth()
            router.replace('/auth/login')
            return
          }
        }

        // Refresh normal do token
        try {
          await auth.refresh()
        } catch {
          await auth.logout()
          router.replace('/auth/login')
        }
      })

      // Botão voltar: auth page → minimiza, app page → volta
      CapApp.addListener('backButton', () => {
        const path = router.currentRoute.value.path
        if (path.startsWith('/auth/') || path === '/') {
          CapApp.minimizeApp()
        } else {
          router.back()
        }
      })
    })
  } catch {
    // Não é ambiente nativo (browser dev) — ignora
  }
})
